// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"c50db0d7","89":"18b8e1f8","430":"b68c4ea9","937":"cceda912"}[chunkId] + ".chunk.css";
};